import { ERROR_ACTION, WAIT_FOR_ACTION } from 'redux-wait-for-action';

export const actionTypes = {
  USER_LOCATIONS_DELETE_POST_FAILURE: 'USER_LOCATIONS_DELETE_POST_FAILURE',
  USER_LOCATIONS_DELETE_POST_REQUEST: 'USER_LOCATIONS_DELETE_POST_REQUEST',
  USER_LOCATIONS_DELETE_POST_SUCCESS: 'USER_LOCATIONS_DELETE_POST_SUCCESS',

  USER_LOCATIONS_GET_FAILURE: 'USER_LOCATIONS_GET_FAILURE',
  USER_LOCATIONS_GET_REQUEST: 'USER_LOCATIONS_GET_REQUEST',
  USER_LOCATIONS_GET_SUCCESS: 'USER_LOCATIONS_GET_SUCCESS',

  USER_LOCATIONS_POST_FAILURE: 'USER_LOCATIONS_POST_FAILURE',
  USER_LOCATIONS_POST_REQUEST: 'USER_LOCATIONS_POST_REQUEST',
  USER_LOCATIONS_POST_SUCCESS: 'USER_LOCATIONS_POST_SUCCESS',
};

export const actionCreators = {
  deletePostRequest: (userIds: Array<number>) => ({
    type: actionTypes.USER_LOCATIONS_DELETE_POST_REQUEST,
    payload: { userIds },
    [WAIT_FOR_ACTION]: actionTypes.USER_LOCATIONS_DELETE_POST_SUCCESS,
    [ERROR_ACTION]: actionTypes.USER_LOCATIONS_DELETE_POST_FAILURE,
  }),
  deletePostSuccess: () => ({
    type: actionTypes.USER_LOCATIONS_DELETE_POST_SUCCESS,
  }),
  deletePostFailure: (error) => ({
    type: actionTypes.USER_LOCATIONS_DELETE_POST_FAILURE,
    error,
  }),

  getRequest: () => ({
    type: actionTypes.USER_LOCATIONS_GET_REQUEST,
    [WAIT_FOR_ACTION]: actionTypes.USER_LOCATIONS_GET_SUCCESS,
    [ERROR_ACTION]: actionTypes.USER_LOCATIONS_GET_FAILURE,
  }),
  getSuccess: (userLocations: Array<any>) => ({
    type: actionTypes.USER_LOCATIONS_GET_SUCCESS,
    payload: { userLocations },
  }),
  getFailure: (error: Error) => ({
    type: actionTypes.USER_LOCATIONS_GET_FAILURE,
    error,
  }),

  postRequest: (userLocations: Array<any>) => ({
    type: actionTypes.USER_LOCATIONS_POST_REQUEST,
    [WAIT_FOR_ACTION]: actionTypes.USER_LOCATIONS_POST_SUCCESS,
    [ERROR_ACTION]: actionTypes.USER_LOCATIONS_POST_FAILURE,
    payload: { userLocations },
  }),
  postSuccess: (userLocations: Array<any>) => ({
    type: actionTypes.USER_LOCATIONS_POST_SUCCESS,
    payload: { userLocations },
  }),
  postFailure: (error: Error) => ({
    type: actionTypes.USER_LOCATIONS_POST_FAILURE,
    error,
  }),
};

export default {
  create: actionCreators,
  type: actionTypes,
};
